module.exports = __webpack_public_path__ + "img/DSC_7064.c08704ca.jpg";